export const createPlayer = () => {
    const playerEL = document.createElement("a-entity");
    playerEL.setAttribute("id", "player-rig");
    playerEL.setAttribute("position", "-5.63 3.91 1.88");
    playerEL.setAttribute("rotation", "0 0 0");
    playerEL.setAttribute(
        "character-controller",
        "pivot: #player-camera;bot: #bot; enabled: true;"
    );
    playerEL.setAttribute("wasd-to-analog2d", "");

    playerEL.innerHTML = `
        <a-entity id="bot" position="0 0 0" rotation="0 0 0">
            <a-entity
                id="avatar"
                class="avatar"
                position="0 0 0.15"
                rotation="0 0 0"
                scale="1 1 1"
            >
            </a-entity>
        </a-entity>

        <a-entity
            id="playerRigCamera"
            position="0 1.65 -0.15"
            rotation="0 0 0"
            nobody="type:dynamic;shape:sphere;sphereRadius:0.05;isTrigger:false;mass:0;"
        >
            <a-entity
                id="player-camera"
                look-controls
                camera="active: true; spectator: false; far:2500000; fov: 80;near: 0.05"
                position="0 0 0"
                rotation="-2 0 0"
                class="camera"
            >
                <!-- <a-entity
                id="gaze-teleport"
                position=""
                teleport-controls=""
                teleport-controls-matrix-auto-update=""
                visible=""
            >
            </a-entity> -->
            </a-entity>
        </a-entity>

        <a-entity id="ray"></a-entity>
    `;

    return playerEL;
};
